import {
    trigger,
    state,
    style,
    animate,
    transition
    // ...
  } from "@angular/animations";

export const fade = trigger("fade", [
    transition("void => active", [
      style({ opacity: 0 }),
      animate(300, style({ opacity: 1 })),
    ]),
    transition("* => void", [animate(300, style({ opacity: 0 }))]),
  ])
 export const fadeInOut = trigger("fadeInOut", [
    state(
      "void",
      style({
        opacity: 0.1,
      })
    ),
    transition("void <=> *", animate(200)),
  ])
 export const fadeimagesInOut = trigger("fadeimagesInOut", [
    state(
      "void",
      style({
        opacity: 0,
      })
    ),
    transition("void <=> *", animate(200)),
  ])
 export const slideInOut= trigger("slideInOut", [
    transition(":enter", [
      style({ transform: "translateY(-100%)" }),
      animate("800ms ease-in", style({ transform: "translateY(0%)" })),
    ]),
    transition(":leave", [
      animate("800ms ease-in", style({ transform: "translateY(-100%)" })),
    ]),
  ])
  export const slideHomeInOut= trigger("slideInOut", [
    transition(":enter", [
      style({ transform: "translateY(20px)" }),
      animate("800ms ease-in", style({ transform: "translateY(0%)" })),
    ]),
    transition(":leave", [
      animate("800ms ease-in", style({ transform: "translateY(-100%)" })),
    ]),
  ])
  // Remove the extra comma here
 export const animSlider= trigger('animSlider', [
    transition(':enter', [
      style({ transform: 'translateX({{direction}}%)' }),
      animate('900ms ease-in', style({ transform: 'translateX(0%)' })),
    ]),
  ])
  export const activeSlide = trigger('activeSlide', [
    state('active', style({
      transform: 'scale(1.4)',
      opacity: 1,
    })),
    state('inActive', style({
      transform: 'scale(0.7)',
      opacity: 0.8,
    })),
    transition('active => inActive', [
      animate('0.5s')
    ]),
    transition('inActive => active', [
      animate('0.5s')
    ])
  ])

  export const slide1InOut = trigger('slideInOut', [
    state('in', style({
      transform: 'translateX(0)'
    })),
    state('out', style({
      transform: 'translateX(-100%)'
    })),
    transition('in => out', animate('300ms ease-in-out')),
    transition('out => in', animate('300ms ease-in-out'))
  ])